export enum DIVIDEND_DETAILS_FORM_KEYS {
  editType = 'editType',
  enrolInPlan = 'enrolInPlan',
  changePaymentType = 'changePaymentType',
}
